import request from "@/utils/request";

export function userOptionList(params) {
  return request({ url: `/users/options/`, method: "get", params });
}
